<div class="h-full pt-20">
    <form
        class="flex h-full flex-col items-center"
        [formGroup]="form">
        <mat-icon
            class="mb-5 !inline-flex items-center justify-center rounded-full bg-gray-300 p-5 text-gray-500">
            lock
        </mat-icon>
        <h1 class="mb-7 text-2xl font-medium">Login</h1>
        <mat-form-field
            class="w-80"
            appearance="fill"
            hideRequiredMarker>
            <mat-label>Email</mat-label>
            <input
                matInput
                formControlName="email" />
        </mat-form-field>
        <mat-form-field
            class="w-80"
            appearance="fill"
            hideRequiredMarker>
            <mat-label>Password</mat-label>
            <input
                matInput
                type="password"
                formControlName="password" />
        </mat-form-field>
        <button
            [disabled]="form.invalid"
            mat-flat-button
            color="primary"
            (click)="signIn()">
            Sign in
        </button>
    </form>
</div>
